export enum PaymentProcessSteps {
  IDLE,
  INITIALIZED,
  RESIGN_INITIALIZED,
  IN_PROCESS,
  VERIFY,
  FAILED,
  SUCCESS,
}
